import request from '@/utils/request'

export function getOrderDetails(data) {
  return request({
    url: '/order/detail',
    method: 'post',
    data,
  })
}

export function getOrdersDetail(data) {
  return request({
    url: '/api/order/detail',
    method: 'post',
    data,
  })
}

export function getAccpetBaseOrderInfo(data) {
  return request({
    url: '/order/getAccpetBaseOrderInfo',
    method: 'get',
    params: data,
  })
}

export function getOrderDetailInformation(data) {
  return request({
    url: '/api/acceptOrderBase/acceptOrderBaseBasic',
    method: 'get',
    params: data,
  })
}

export function getMonthBasicList(data) {
  return request({
    url: '/api/acceptOrderItemDetail/acceptItemDetail',
    method: 'get',
    data,
  })
}

export function getOrderDetailsList(data) {
  return request({
    url: `/api/acceptOrderDetail/queryAcceptOrderDetail/${data.acceptOrderBaseId}`,
    method: 'get',
    params: data,
  })
}

export function getQuotationInformation(data) {
  return request({
    url: '/api/getQuotationInformation',
    method: 'get',
    data,
  })
}

export function getServiceDetailInformation(data) {
  return request({
    url: '/api/serviceDetailInformation',
    method: 'get',
    data,
  })
}

export function getOrderDetailList(data) {
  return request({
    url: '/api/acceptOrderDetail2/queryAcceptOrderDetail2',
    method: 'get',
    data,
  })
}

export function getOrderbillingList(data) {
  return request({
    url: `/api/acceptOrderBill/acceptOrderBill/${data.acceptOrderBaseId}`,
    method: 'get',
    params: data,
  })
}

export function getSpecificProductsCd() {
  return request({
    url: '/data/getSpecificProductsCd',
    method: 'get',
  })
}

export function getWorkScheduleProductsCd() {
  return request({
    url: '/data/getWorkScheduleProductsCd',
    method: 'get',
  })
}

export function getProposalDetail(proposalBaseId) {
  return request({
    url: `/api/proposalBase/${proposalBaseId}`,
    method: 'get',
  })
}

export function getOrderDetailsListDetail() {
  return request({
    url: '/api/getOrderDetailsListDetail',
    method: 'get',
  })
}

export function getTcntbaspOne() {
  return request({
    url: '/api/getTcntbaspOne',
    method: 'get',
  })
}

export function getProposalBaseItemDetail(proposalBaseId) {
  return request({
    url: '/api/proposalBase/item-details',
    method: 'get',
    params: { proposalBaseId: proposalBaseId },
  })
}
